<template>
	<div>...</div>
</template>
<script>
	import aBox from 'box';
	import aButton from 'btn';
	import aModal from 'modal';
	import wbs from 'js/http';
	import clone from 'js/clone';
	import toastr from 'toastr';

	export default {
		name: 'AppLincense',
		components: { aBox, aButton, aModal },
		data() {
			return {};
		},
		mounted() {
			this.$emit('setHeader', [
				'O.S. Estáticas',
				'Gerenciamento de perfis de acesso!',
			]);
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/settings/os-statics/index.vue